import { type Point } from '../../../utils/math';
import { type PointBezierHandle } from '../../poly';
import { offsetHandles } from '../../poly/utils/bezierHandles';
import { getPathFromPoints } from '../../poly/utils/path';

export const getStrokePath = (
  points: Point[],
  bezierHandles: PointBezierHandle[] | undefined,
  offset: number,
): Path2D => {
  const offsetPoints = points.map(
    (p) => [p[0] + offset, p[1] + offset] as Point,
  );

  if (bezierHandles != null && bezierHandles.length === points.length) {
    const offsetHandlesForPath = offsetHandles(bezierHandles, offset, offset)!;
    return getPathFromPoints(offsetPoints, offsetHandlesForPath, false);
  }

  const path = new Path2D();
  path.moveTo(offsetPoints[0][0], offsetPoints[0][1]);
  for (let i = 1; i < offsetPoints.length - 1; i++) {
    const [x1, y1] = offsetPoints[i];
    const [x2, y2] = offsetPoints[i + 1];
    const midX = (x1 + x2) / 2;
    const midY = (y1 + y2) / 2;
    path.quadraticCurveTo(x1, y1, midX, midY);
  }
  const last = offsetPoints[offsetPoints.length - 1];
  path.lineTo(last[0], last[1]);
  return path;
};
